import React, { useContext } from 'react';
import { SearchList } from '../SearchList/SearchList';
import { SearchContext } from '../SearchBar';
import useMyWorkspacesChildren from '../../../../../redux/workspace/hooks/useMyWorkspacesChildren';
import { WorkspaceAPIResponse } from '../../../../../redux/workspace/WorkspaceAPI.model';
import { useAppSelector } from '../../../../../redux/store.model';
import { getAllWorkspaceByIdSelector } from '../../../../../redux/workspace/selectors/Workspace.selectors';

export const MarketsSearch = () => {
  const { search } = useContext(SearchContext);

  const searchQuery = search.toLowerCase();

  const { data: workspacesChildren, isLoading: workspacesChildrenLoading } =
    useMyWorkspacesChildren();

  const workspaceIds = Object.keys(workspacesChildren || {});
  const workspaces = useAppSelector(getAllWorkspaceByIdSelector);

  const isLoading = workspacesChildrenLoading;
  const filteredWorkspaces =
    workspaces
      ?.filter(Boolean)
      ?.filter((workspaceUnit: WorkspaceAPIResponse) =>
        workspaceIds.includes(workspaceUnit.id ?? '')
      )
      ?.filter((workspaceUnit: WorkspaceAPIResponse) =>
        workspaceUnit.name.toLowerCase().includes(searchQuery)
      )
      .map((item) => {
        return { ...item, key: item.id ?? '', value: item.name ?? '' };
      }) ?? [];

  return (
    <SearchList
      header="search.markets"
      list={filteredWorkspaces}
      loading={isLoading}
    />
  );
};
